var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{key:'donut',ref:"donut",attrs:{"type":"radialBar","height":_vm.boxHeight >= 300 ? 240 : '70%',"options":_vm.goalOverviewRadialBar,"series":_vm.series}})}
var staticRenderFns = []

export { render, staticRenderFns }